import { ProfessionalData } from './../model/professional-data';
import { Injectable } from '@angular/core';
import { JourneyService } from '../../shared/service/journey/journey.service';
import { TrackTypes } from '../../shared/service/journey/tracks/model/track-types';

@Injectable({
  providedIn: 'root'
})
export class ProfessionService {

  private readonly STEP_CODE = 'professional-data';

  originPrevious: string;
  originNamePrevious: string;
  professionPrevious: string;
  professionNamePrevious: string;
  incomeRequiredPrevious: boolean;
  patrimonyRequiredPrevious: boolean;

  constructor(private journeyService: JourneyService) {
  }

  public setOriginIncomeName(originIncomeName: string, originCode: string, save: boolean) {
    const idNotProf = ['11839', '11843', '11838', '11841', '11834', '11837', '12230', '11840'];
    const filterId = idNotProf.find(x => x === originCode);

    if (!save || save && filterId) {
      this.journeyService.registratioJourney.data.professionalData.originIncomeName = originIncomeName;
    } else {
      this.originNamePrevious = this.journeyService.registratioJourney.data.professionalData.originIncomeName;
      this.journeyService.registratioJourney.data.professionalData.originIncomeNamePrevious = this.originNamePrevious
      this.journeyService.registratioJourney.data.professionalData.originIncomeName = originIncomeName;
    }
  }

  public setOriginIncome(originIncome: string, save: boolean) {
    const idNotProf = ['11839', '11843', '11838', '11841', '11834', '11837', '12230', '11840'];
    const filterId = idNotProf.find(x => x === originIncome);

    if (!save || save && filterId) {
      this.journeyService.registratioJourney.data.professionalData.originIncome = originIncome;
      this.journeyService.registratioJourney.data.professionalData.entityThatWorks = undefined;
      this.journeyService.registratioJourney.data.professionalData.entityCnpj = undefined;
      this.journeyService.registratioJourney.data.professionalData.professionName = undefined;
      this.journeyService.registratioJourney.data.professionalData.profession = undefined;
      this.setIsCompleteStepData();
      this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.professionalData);
      this.originPrevious = undefined;
    } else {
      this.originPrevious = this.journeyService.registratioJourney.data.professionalData.originIncome;
      this.journeyService.registratioJourney.data.professionalData.originIncomePrevious = this.originPrevious;
      this.journeyService.registratioJourney.data.professionalData.originIncome = originIncome;
    }
  }

  public setProfessionName(professionName: string, origin: string, save: boolean) {
    this.journeyService.registratioJourney.data.professionalData.professionName = professionName;
  }

  public setProfession(profession: string, origin: string, save: boolean) {
    if (!save || save && (origin === '11833')) {
      this.journeyService.registratioJourney.data.professionalData.profession = profession;
      this.journeyService.registratioJourney.data.professionalData.entityThatWorks = undefined;
      this.journeyService.registratioJourney.data.professionalData.entityCnpj = undefined;
      this.setIsCompleteStepData();
      this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.professionalData);
    }
    this.journeyService.registratioJourney.data.professionalData.profession = profession;
    this.setIsCompleteStepData();
    this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.professionalData);
  }

  public setIncomeRequired(originIncome: string, check: boolean, save: boolean) {
    const idNotProf = ['11839', '11843', '11838', '11841', '11834', '11837', '12230', '11840'];
    const filterId = idNotProf.find(x => x === originIncome);
    
    if (!save || save && filterId) {
      this.journeyService.registratioJourney.data.professionalData.incomeRequired = check;
      this.setIsCompleteStepData();
      this.incomeRequiredPrevious = undefined;
    } else {
      this.incomeRequiredPrevious = this.journeyService.registratioJourney.data.professionalData.incomeRequired;
      this.journeyService.registratioJourney.data.professionalData.incomeRequiredPrevious = this.incomeRequiredPrevious;
      this.journeyService.registratioJourney.data.professionalData.incomeRequired = check;
    }
  }

  public setPatrimonyRequired(originIncome: string, check: boolean, save: boolean) {
    const idNotProf = ['11839', '11843', '11838', '11841', '11834', '11837', '12230', '11840'];
    const filterId = idNotProf.find(x => x === originIncome);

    if (!save || save && filterId) {
      this.journeyService.registratioJourney.data.professionalData.patrimonyRequired = check;
      this.setIsCompleteStepData();
      this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.professionalData);
      this.patrimonyRequiredPrevious = undefined;
    } else {
      this.patrimonyRequiredPrevious = this.journeyService.registratioJourney.data.professionalData.patrimonyRequired;
      this.journeyService.registratioJourney.data.professionalData.patrimonyRequiredPrevious = this.patrimonyRequiredPrevious;
      this.journeyService.registratioJourney.data.professionalData.patrimonyRequired = check;
    }
  }

  public setEntityCnpj(entityCnpj: string) {
    this.journeyService.registratioJourney.data.professionalData.entityCnpj = entityCnpj;
  }

  public setEntityThatWorks(entityThatWorks: string) {
    this.journeyService.registratioJourney.data.professionalData.entityThatWorks = entityThatWorks;
    this.setIsCompleteStepData();
    this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.professionalData);
  }

  setIsCompleteStepData() {
    this.journeyService.registratioJourney.data.professionalData.isCompleted = this.professionalDataIsComplete();
  }

  professionalDataIsComplete(): boolean {
    const id = this.journeyService.registratioJourney.data.professionalData?.originIncome;

    const idNeedAllFields = ['11829', '11846', '11845', '11835', '11836', '11832'];
    const idNeedProfessionField = ['11842', '11831', '11830', '11833'];

    if (!this.journeyService.registratioJourney.data.professionalData
      || !this.journeyService.registratioJourney.data.professionalData?.originIncome
    ) {
      return false;
    }

    if (idNeedAllFields.indexOf(id) >= 0 &&
      (!this.journeyService.registratioJourney.data.professionalData?.profession
        || !this.journeyService.registratioJourney.data.professionalData?.entityCnpj
        || !this.journeyService.registratioJourney.data.professionalData?.entityThatWorks)
    ) {
      return false;
    }

    if (id === '12229' &&
      (!this.journeyService.registratioJourney.data.professionalData?.entityCnpj
        || !this.journeyService.registratioJourney.data.professionalData?.entityThatWorks)
    ) {
      return false;
    }

    if (idNeedProfessionField.indexOf(id) >= 0
      && !this.journeyService.registratioJourney.data.professionalData?.profession) {
      return false;
    }

    return true;
  }

  resetPreviousData() {
    this.journeyService.registratioJourney.data.professionalData.originIncomePrevious = undefined;
    this.journeyService.registratioJourney.data.professionalData.originIncomeNamePrevious = undefined;
    this.journeyService.registratioJourney.data.professionalData.entityThatWorksPrevious = undefined;
    this.journeyService.registratioJourney.data.professionalData.entityCnpjPrevious = undefined;
    this.journeyService.registratioJourney.data.professionalData.incomeRequiredPrevious = undefined;
    this.journeyService.registratioJourney.data.professionalData.patrimonyRequiredPrevious = undefined;
  }
}
